<template>
    <div class="box">
        <div class="loading-spinner-outer" v-if="saving_files">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
            </div>
        </div>
        <div class="box-content">
          <div class="form-group">
            <label>Title</label>
            <input class="form-control" type="text" v-model="promotional_slide.title">
          </div>
          <div class="form-group">
            <label>Content</label>
            <textarea class="form-control" rows="4" v-model="promotional_slide.content"></textarea>
          </div>
          <div class="flex-xs">
            <div class="form-group mr-3-xs">
              <label>Text Colour</label>
              <input class="form-control" type="color" v-model="promotional_slide.text_colour">
            </div>
            <div class="form-group ml-3-xs">
              <label>Link</label>
              <input class="form-control" type="text" v-model="promotional_slide.link">
            </div>
          </div>
          <div class="form-group">
            <label class="checkbox">
              <input type="checkbox" v-model="promotional_slide.active">
              <span class="checkbox-label">Active</span>
            </label>
          </div>
          <div class="form-group">
            <label>Image Position</label>
            <select class="form-control" v-model="promotional_slide.main_image_side">
              <option :value="'left'">Left</option>
              <option :value="'right'">Right</option>
              <option :value="'none'">No Image</option>
            </select>
          </div>
          <div class="flex-xs">
            <div class="flex-1 pr-3-xs">
              <div class="form-group mb-0 flex flex-col">
                <label>Upload Main Image</label>
                <form :action="`${$aws_upload_url}`" method="post"
                      enctype="multipart/form-data" id="main_image_amazon_form">
                  <input type="hidden" name="policy" :value="aws_policy">
                  <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                  <input type="hidden" name="x-amz-credential" :value="aws_credential">
                  <input type="hidden" name="x-amz-date" :value="aws_date">
                  <input type="hidden" name="x-amz-signature" :value="aws_signature">
                  <input type="hidden" name="acl" value="private">
                  <input type="hidden" name="Content-Type" v-model="main_image_filetype">
                  <input type="hidden" name="key" v-model="promotional_slide.main_image_url">
                </form>
                <vue-dropzone
                  ref="mainFileUploadDropzone"
                  id="main-file-dropzone"
                  :options="dropzoneOptions"
                  v-on:vdropzone-file-added="mainFileAddedToDropZone"
                  v-on:vdropzone-removed-file="mainFileRemovedFromDropZone"
                  :useCustomSlot="true"
                >
                  <div>
                    <div class="mb-3">
                      DRAG AND DROP FILE
                    </div>
                    <div class="mb-3">
                      OR
                    </div>
                    <div>
                      <a class="btn-secondary-outline">
                        Choose a file
                      </a>
                    </div>
                  </div>
                </vue-dropzone>
              </div>
            </div>
            <div class="flex-1 pl-3-xs">
              <div class="form-group mb-0 flex flex-col">
                <label>Upload Background Image</label>
                <form :action="`${$aws_upload_url}`" method="post"
                      enctype="multipart/form-data" id="background_image_amazon_form">
                  <input type="hidden" name="policy" :value="aws_policy">
                  <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                  <input type="hidden" name="x-amz-credential" :value="aws_credential">
                  <input type="hidden" name="x-amz-date" :value="aws_date">
                  <input type="hidden" name="x-amz-signature" :value="aws_signature">
                  <input type="hidden" name="acl" value="private">
                  <input type="hidden" name="Content-Type" v-model="background_image_filetype">
                  <input type="hidden" name="key" v-model="promotional_slide.background_image_url">
                </form>
                <vue-dropzone
                  ref="backgroundFileUploadDropzone"
                  id="background-file-dropzone"
                  :options="dropzoneOptions"
                  v-on:vdropzone-file-added="backgroundFileAddedToDropZone"
                  v-on:vdropzone-removed-file="backgroundFileRemovedFromDropZone"
                  :useCustomSlot="true"
                >
                  <div>
                    <div class="mb-3">
                      DRAG AND DROP FILE
                    </div>
                    <div class="mb-3">
                      OR
                    </div>
                    <div>
                      <a class="btn-secondary-outline">
                        Choose a file
                      </a>
                    </div>
                  </div>
                </vue-dropzone>
              </div>
            </div>
          </div>
          <div class="mt-3 mb-3">
            <a class="promotional-slide"
               :href="promotional_slide.link"
               target="_blank"
               :style="slideStyle(promotional_slide)"
               :class="{
                  '_image-left': promotional_slide.main_image_side === 'left',
                  '_image-right': promotional_slide.main_image_side === 'right',
                  '_image-none': promotional_slide.main_image_side === 'none'
                }">
              <div class="promotional-slide-image">
                <img :src="main_image_preview">
              </div>
              <div class="promotional-slide-body">
                <h1 class="promotional-slide-title">{{ promotional_slide.title }}</h1>
                <div class="promotional-slide-content">
                  {{ promotional_slide.content }}
                </div>
              </div>
            </a>
          </div>
          <div class="align-right">
            <a @click.stop.prevent="save" class="btn-primary">
              Save
            </a>
          </div>
        </div>
    </div>
</template>

<script>

  import vue2Dropzone from 'vue2-dropzone';

  export default {
    mounted() {
    },
    props: [
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature',
    ],
    components: {
      'vue-dropzone': vue2Dropzone,
    },
    data() {
      return {
        promotional_slide: {
          title: 'Enter a title for this slide',
          content: 'Enter some content for this slide',
          text_colour: '#000000',
          main_image_url: null,
          main_image_side: 'left',
          background_image_url: null,
          link: '',
          active: true,
        },
        saving_files: false,
        main_image_preview: null,
        main_image_filename: null,
        main_image_filetype: null,
        main_image_uploaded_file: null,
        background_image_preview: null,
        background_image_filename: null,
        background_image_filetype: null,
        background_image_uploaded_file: null,
        dropzoneOptions: {
          url: '/',
          autoProcessQueue: false,
          uploadMultiple: false,
          addRemoveLinks: true,
        },
      }
    },
    methods: {
      mainFileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.'+extension, '');

        const allowed_extensions = [
          'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp', 'tif',
        ];

        if(!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.mainFileUploadDropzone.dropzone.removeAllFiles();
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: jpg, png, svg, gif, bmp, tif',
          });
          return;
        }

        if (this.$refs.mainFileUploadDropzone.dropzone.files.length > 1) {
          this.$refs.mainFileUploadDropzone.dropzone.removeFile(this.$refs.mainFileUploadDropzone.dropzone.files[0]);
        }

        const filename = 'promotional_slides/main_images/'+ original_file_name + '_' + Date.now();
        this.main_image_filename = filename + '.' + extension;
        this.promotional_slide.main_image_url = this.main_image_filename;

        this.main_image_filetype = uploadedFile.type;
        this.main_image_uploaded_file = uploadedFile;
        this.main_image_preview = URL.createObjectURL(uploadedFile);
      },
      mainFileRemovedFromDropZone(file) {
        this.main_image_filetype = null;
        this.main_image_uploaded_file = null;
        this.main_image_filename = null;
        this.main_image_preview = null;
      },
      backgroundFileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.'+extension, '');

        const allowed_extensions = [
          'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp', 'tif',
        ];

        if(!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.backgroundFileUploadDropzone.dropzone.removeAllFiles();
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: jpg, png, svg, gif, bmp, tif',
          });
          return;
        }

        if (this.$refs.backgroundFileUploadDropzone.dropzone.files.length > 1) {
          this.$refs.backgroundFileUploadDropzone.dropzone.removeFile(this.$refs.backgroundFileUploadDropzone.dropzone.files[0]);
        }

        const filename = 'promotional_slides/backgrounds/'+ original_file_name + '_' + Date.now();
        this.background_image_filename = filename + '.' + extension;
        this.promotional_slide.background_image_url = this.background_image_filename;

        this.background_image_filetype = uploadedFile.type;
        this.background_image_uploaded_file = uploadedFile;
        this.background_image_preview = URL.createObjectURL(uploadedFile);
      },
      backgroundFileRemovedFromDropZone(file) {
        this.background_image_filetype = null;
        this.background_image_uploaded_file = null;
        this.background_image_filename = null;
        this.background_image_preview = null;
      },
      save() {
        this.saving_files = true;

        const uploadPromises = [];

        if (this.main_image_uploaded_file) {
          const mainFormData = new FormData(document.querySelector('#main_image_amazon_form'));
          mainFormData.append('file', this.main_image_uploaded_file);

          uploadPromises.push(
            axios({
              method: 'post',
              url: this.$aws_upload_url,
              data: mainFormData,
              headers: { 'Content-Type': 'multipart/form-data' }
            }).catch((error) => {
              console.error('Main image upload failed:', error);
              throw new Error('Main image upload failed.');
            })
          );
        }

        if (this.background_image_uploaded_file) {
          const backgroundFormData = new FormData(document.querySelector('#background_image_amazon_form'));
          backgroundFormData.append('file', this.background_image_uploaded_file);

          uploadPromises.push(
            axios({
              method: 'post',
              url: this.$aws_upload_url,
              data: backgroundFormData,
              headers: { 'Content-Type': 'multipart/form-data' }
            }).catch((error) => {
              console.error('Background image upload failed:', error);
              throw new Error('Background image upload failed.');
            })
          );
        }

        Promise.all(uploadPromises)
        .then(() => {
          this.saveNewSlide();
        })
        .catch((error) => {
          Swal.fire({
            title: 'Upload Failed',
            icon: 'error',
            text: error.message || 'One or more files failed to upload. Please try again.',
          });
          this.saving_files = false;
        });
      },
      saveNewSlide: _.debounce(function () {
        axios.post('/promotional-slides/create', {
          title: this.promotional_slide.title,
          content: this.promotional_slide.content,
          text_colour: this.promotional_slide.text_colour,
          main_image_url: this.main_image_filename,
          main_image_side: this.promotional_slide.main_image_side,
          background_image_url: this.background_image_filename,
          link: this.promotional_slide.link,
          active: this.promotional_slide.active,
        }).then((response) => {
          window.location.href = response.data;
        });
      }, 250),
      slideStyle(promotional_slide) {
        return {
          backgroundImage: `url(${this.background_image_preview})`,
          color: promotional_slide.text_colour,
          backgroundSize: 'cover',
        };
      },
    },
  };
</script>
